module.exports = file => () => {
    return import('@/view/' + file + '.vue');
    // if (sessionStorage.getItem('acc') === 'plant') {
    //   return import('@/view/plant/' + file + '.vue');
    // } else {
    //   return import('@/view/business/' + file + '.vue');
    // }
};



// WEBPACK FOOTER //
// ./src/router/_import_production.js